module.exports = __webpack_public_path__ + "static/blake-bw@2x-e8108a975f2ffc9564b81228aa963028.png";